import { ThunkAction } from 'redux-thunk';
import { AppState } from '../../store';
import { AnyAction } from 'redux';
import * as Actions from './actions';
import * as UserActions from '../user/actions';
import { homehubApiPath } from '../../../config/baseConfig';
import { ALREADY_APPLIED_CODE } from './types';

export const verifyIdentification = (
  organizationId: string,
  usageInfoId: string
): ThunkAction<Promise<void>, AppState, {}, AnyAction> => async (
  dispatch,
  getState
) => {
  try {
    dispatch(Actions.verifyIdentification());
    const formParam = getState().identification.parameters;
    const birthday = formParam.birthday;
    // API 側は YYYY-MM-DD の形なので整形する
    const formattedBirthday =
      birthday.slice(0, 4) +
      '-' +
      birthday.slice(4, 6) +
      '-' +
      birthday.slice(6, 8);

    const endpoint = `${homehubApiPath}/applications/identification/verify`;
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    };
    const method = 'POST';

    const body = JSON.stringify({
      organizationId,
      usageInfoId,
      birthday: formattedBirthday
    });

    await fetch(endpoint, {
      method,
      headers,
      body,
      mode: 'cors'
    })
      .then(async res => {
        if (res.status !== 200) {
          const json = await res.json().catch(() => ({}));
          // 失敗の場合の処理
          if (res.status === 403) {
            console.log('already locked out this contract.', res);
            dispatch(Actions.failedToVerifyIdentification('locked'));
          } else if (res.status === 409) {
            console.log('already applied contract.', res);
            const status =
              json.code === ALREADY_APPLIED_CODE
                ? 'already_applied'
                : 'canceled';
            dispatch(Actions.failedToVerifyIdentification(status));
          } else {
            console.log('failed to verify identity.', res);
            dispatch(Actions.failedToVerifyIdentification('unauthorized'));
          }
          return;
        }

        dispatch(UserActions.setBirthday(birthday));
        dispatch(Actions.successToVerifyIdentification());
      })
      .catch(error => {
        console.error(error);
        dispatch(Actions.failedToVerifyIdentification('internal'));
      });
  } catch (error) {
    console.error(error);
    dispatch(Actions.failedToVerifyIdentification('internal'));
  }
};
